var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DisposalOrdersCreationUser',{attrs:{"DO":_vm.DO},on:{"prepareSave":_vm.prepareSave,"saveInDraft":_vm.saveInDraft}})
}
var staticRenderFns = []

export { render, staticRenderFns }